import { render, staticRenderFns } from "./AcquistiSospesi.vue?vue&type=template&id=3957d9d9"
import script from "./AcquistiSospesi.vue?vue&type=script&lang=js"
export * from "./AcquistiSospesi.vue?vue&type=script&lang=js"
import style0 from "./AcquistiSospesi.vue?vue&type=style&index=0&id=3957d9d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports